import React, { useState } from 'react';
import styled from 'styled-components';
import { ethers } from 'ethers';
import { Button, Modal, Form, Input, Message } from 'semantic-ui-react';
import SocialVaultContract from '../artifacts/contracts/SocialVault.sol/SocialVault.json';

interface IBuyStakeProps {
  address: string;
  stakedAmount: string;
  sellingFor: string;
  url?: string;
  name: string;
}

const BuyStake = (props: IBuyStakeProps): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const ethStaked = ethers.utils.formatEther(props.stakedAmount);
  const ethSellingFor = ethers.utils.formatEther(props.sellingFor);

  function bringUpModal(address: string) {
    setErrorMessage('');
    setOpen(true);
  }

  async function buyStake() {
    try {
      setLoading(true);
      const provider: any = new ethers.providers.Web3Provider((window as any).ethereum);
      const userSocialVault: any = new ethers.Contract(
        props.address,
        SocialVaultContract.abi,
        provider.getSigner(0)
      );

      const overrides = {
        value: ethers.utils.parseEther(ethSellingFor),
      }

      await userSocialVault.buyStake(props.address, overrides);
      setOpen(false);
    } catch (e) {
      setErrorMessage((e as Error).message);
    }
    setLoading(false);
  }

  return(
    <>
    <CardDiv>
      <ColumnOne>
          <img style={{width: "38px"}} src={props.url}/>
        </ColumnOne>
        <ColumnTwo>
          { props.name }
        </ColumnTwo>
        <ColumnEight>
          { `Stake: ${ethStaked} / Ask: ${ethSellingFor} ETH` }
        </ColumnEight>
        <ColumnOne>
          <p style={{fontWeight: "bold", cursor: "pointer", display:"inline-block"}} onClick={() => bringUpModal(props.address)}>buy</p>
        </ColumnOne>
    </CardDiv>
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
    >
      <Modal.Header>Are you sure you want to buy this stake?</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form error={!!errorMessage}>
          <Form.Field>
            <label>Buy Stake For</label>
            <Input
                disabled={true}
                label="eth"
                labelPosition="right"
                value={ethSellingFor}
            />
            </Form.Field>
            <Message error header="Oops!" content={errorMessage} />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          content="Stake"
          labelPosition='right'
          icon='checkmark'
          onClick={() => buyStake()}
          positive
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
    </>
  )
}

export const ColumnOne = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 6.25%;
`;

export const ColumnTwo = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 12.50%;
`;

export const ColumnEight = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 50%;
`;

export const CardDiv = styled.div`
    margin-top: 10px;
    background: #DCDCDC;
    width: 100%;
    font-size: 0.6em;
    border-radius: 0px;
    float: none;
    height: 60px;
    color: black;
`;

export default BuyStake;
